import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const joinUrl = (code) => `${window.location.origin}/join/${code}`;
const detail = (e, fallback) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : fallback);

// The join link for one company/depot ('' = whole company), created on first use.
export const useJoinLink = (depotId, enabled) => {
  const [link, setLink] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!enabled) return;
    setLink(null);
    api.joinLink(depotId).then(setLink).catch((e) => toast.error(detail(e, "Could not load the join link")));
  }, [depotId, enabled]);
  const reset = useCallback(async () => {
    setBusy(true);
    try { setLink(await api.resetJoinLink(depotId)); toast.success("New link made — the old link and QR code no longer work"); }
    catch (e) { toast.error(detail(e, "Could not reset the link")); }
    finally { setBusy(false); }
  }, [depotId]);
  return { link, busy, reset };
};

export const copyText = async (text, what = "Link copied") => {
  try { await navigator.clipboard.writeText(text); toast.success(what); }
  catch { toast.message(text); }
};

export const shareLink = async (link) => {
  const url = joinUrl(link.code);
  const text = `Join the ${link.company_name}${link.depot_name ? ` (${link.depot_name})` : ""} crew on Cross Jobs:`;
  if (navigator.share) {
    try { await navigator.share({ title: "Join our crew on Cross Jobs", text, url }); } catch { /* closed */ }
    return;
  }
  copyText(`${text} ${url}`);
};

export const whatsappHref = (link) =>
  `https://wa.me/?text=${encodeURIComponent(`Join the ${link.company_name} crew on Cross Jobs: ${joinUrl(link.code)}`)}`;
